<template>
  <div>
    <div class="cover-wrap">
      <div class="cover f-left">
        <ImageClip
          :class="{
            'vip-style':
              $store.state.commonSetting.switch_state == 1 &&
              vip_guide &&
              (!has_buy || !isValid) &&
              course.course_type == 1,
          }"
          :src="course.cover_img"
          :width="420"
          :height="279"
          :radius="5"
        ></ImageClip>
        <div
          class="vip-guide"
          v-if="
            $store.state.commonSetting.switch_state == 1 &&
            vip_guide &&
            (!has_buy || !isValid) &&
            course.course_type == 1
          "
        >
          <div class="guide-content">
            <img src="@/assets/images/course/course-v@2x.png" />
            <span>{{ vip_guide }}</span>
          </div>
          <div
            class="open-vip"
            v-if="isShowOpenVip && course.course_type == 1"
            @click="openVip()"
          >
            <span>立即开通</span>
            <img src="@/assets/images/course/open-icon@2x.png" />
          </div>
        </div>
      </div>
      <div class="right f-left">
        <div class="course-detail">
          <div class="title-wrap">
            <img
              v-if="course.cert == 1"
              class="tag-cert"
              src="@/assets/images/cert/tag@2x.png"
            />
            <span class="title">{{ course.title }}</span>
          </div>
          <div class="period">
            <template v-if="course.start_play_date">
              <span v-if="course.course_type != 3">
                {{ course.start_play_date | tsFormat("yyyy/MM/dd") }}-{{
                  course.end_play_date | tsFormat("yyyy/MM/dd")
                }}
              </span>
              <span v-else>
                {{ course.start_play_date_copy }}-{{
                  course.end_play_date_copy
                }}
              </span>
              <span v-if="course.course_type != 3" class="ver-line"></span>
            </template>
            <span v-if="course.course_type != 3">
              共{{ course.total_periods }}课时
            </span>
          </div>
          <CourseTimeRange
            v-if="course.course_type == 3"
            :course="course"
          ></CourseTimeRange>
          <CourseShowValid
            v-if="course.course_type != 3"
            :course="course"
          ></CourseShowValid>
          <div class="apply" v-if="course.course_type == 7">
            <div class="right">
              <div class="item">
                <span class="label">报名截止：</span>
                <span>{{ course.enter_end_date_str }}</span>
              </div>
              <div class="item">
                <span class="label">开课地点：</span>
                <span>
                  {{
                    course.province_name +
                    course.city_name +
                    course.district_name +
                    course.address
                  }}
                </span>
              </div>
            </div>
          </div>
          <div
            class="coupon-service-wrap"
            v-if="
              (couponList.length > 0 && !isValid) ||
              (course.service && course.service.length > 0)
            "
          >
            <div class="coupon-wrap" v-if="couponList.length > 0 && !isValid">
              <span class="label">优惠券：</span>
              <Coupon @getCoupon="getCoupon" :couponList="couponList"></Coupon>
            </div>
            <CourseShowService :course="course"></CourseShowService>
          </div>
          <div
            class="placeholder"
            v-if="couponList.length == 0 && course.service.length == 0"
          ></div>
        </div>
        <div class="footer clearfix" :class="{ free: course.is_free }">
          <CourseClass
            v-if="course.course_type == 2 && course.in_buy != 1"
            :course="course"
          ></CourseClass>
          <CourseShowPrice :course="course"></CourseShowPrice>
          <CourseShowBuy
            :course="course"
            :has_buy="has_buy"
            :vip_guide="vip_guide"
            @buy="buy"
            @goToStudy="goToStudy"
            @vipFree="vipFree"
          ></CourseShowBuy>
        </div>
      </div>
      <a class="share" @click="onShareClick"></a>
    </div>
    <Lianbao
      :course="course"
      :discountList="discountList"
      :discountCourseList="discountCourseList"
      @discountBuy="val => $emit('discountBuy', val)"
      @changeDiscount="val => $emit('changeDiscount', val)"
    ></Lianbao>
    <!--PC端课程详情讲师!-->
    <CourseShowTabs
      :teachers="teachers"
      :teaching="teaching"
      :course="course"
      :recommendCourses="recommendCourses"
      :exams="exam"
      v-if="course.course_type == 3"
    ></CourseShowTabs>

    <CourseShowTabs
            :teachers="teachers"
            :teaching="teaching"
            :course="course"
            :recommendCourses="recommendCourses"
            :exams="exam"
            v-if="course.course_type !=3"
    ></CourseShowTabs>

  </div>
</template>
<script>
import Coupon from "../Coupon.vue";
import Lianbao from "./Lianbao.vue";
import CourseShowService from "./CourseShowService.vue";
import CourseShowValid from "./CourseShowValid.vue";
import CourseShowBuy from "./CourseShowBuy.vue";
import CourseShowPrice from "./CourseShowPrice.vue";
import CourseClass from "./CourseClass.vue";
import CourseTimeRange from "./CourseTimeRange.vue";
import CourseShowTabs from "./CourseShowTabs.vue";

export default {
  name: "RichCourseShow",
  components: {
    Coupon,
    Lianbao,
    CourseShowService,
    CourseShowValid,
    CourseShowBuy,
    CourseShowPrice,
    CourseClass,
    CourseTimeRange,
    CourseShowTabs,
  },
  props: {
    course: {
      type: Object,
      default: () => {
        return {};
      },
    },
    has_buy: {
      type: Boolean,
      default: false,
    },
    couponList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    teachers: {
      type: Array,
      default: () => {
        return [];
      },
    },
    teaching: {
      type: Array,
      default: () => {
        return [];
      },
    },
    courses: {
      type: Array,
      default: () => {
        return [];
      },
    },
    recommendCourses: {
      type: Array,
      default: () => {
        return [];
      },
    },
    discountList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    discountCourseList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    exam: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    course: function () {
      this.$nextTick(() => {
        this.removeImageTitle();
      });
    },
  },
  computed: {
    isValid() {
      return this.$services.CourseService.checkBuyValid(this.course);
    },
    // 会员引导内容
    vip_guide() {
      if (!this.course.vipData.firstVip.id) return "";
      let user_info = this.$store.state.user_info;
      let guide = `开通${this.course.vipData.firstVip.name}即可免费报名该课程`;
      if (this.getIsExpire) {
        return guide;
      }
      //用户是会员
      if (this.$store.state.token && user_info.vip_info.vip_id) {
        if (this.course.vipData.is_vip_course == 1) {
          guide = `您已是${user_info.vip_info.name}，可以免费学习该课程，快去报名吧`;
        } else {
          guide = `您是${user_info.vip_info.name}，不能免费学习该课程，如有疑问请咨询客服`;
        }
      }
      return guide;
    },
    isShowOpenVip() {
      if (
        !this.$store.state.token ||
        this.getIsExpire ||
        (this.$store.state.user_info.vip_info &&
          !this.$store.state.user_info.vip_info.vip_id)
      ) {
        return true;
      } else {
        return false;
      }
    },
    //判断会员是否过期
    getIsExpire() {
      if (this.course.userVipData.end_at) {
        const now = this.$actionTool.getCurTimestamp(); //当前时间的时间戳
        if (now > this.course.userVipData.end_at) {
          //如果当前时间大于会员到期时间，说明已过期
          return true;
        }
      }
      return false;
    },
  },
  async mounted() {
    await this.$nextTick();
    this.removeImageTitle();
  },
  methods: {
    removeImageTitle() {
      let courseDetail = document.getElementById("course-detail");
      if (!courseDetail) {
        return;
      }
      courseDetail.querySelectorAll("img").forEach(ele => {
        ele.removeAttribute("title");
      });
    },
    onShareClick() {
      this.$emit("shareClick");
    },
    goToStudy() {
      this.$emit("goToStudy");
    },
    buy() {
      this.$emit("buy");
    },
    getCoupon(id) {
      this.$emit("getCoupon", id);
    },
    openVip() {
      this.$emit("openVip");
    },
    vipFree() {
      this.$emit("vipFree");
    },
  },
};
</script>
<style scoped lang="scss">
.cover-wrap {
  background: rgba(255, 255, 255, 1);
  border-radius: 5px;
  background-size: 1240px 369px;
  background-position: -20px -5px;
  padding: 24px 33px 0 30px;
  position: relative;
  margin-bottom: 20px;
  display: flex;

  .cover {
    margin: 0 36px 31px 0;
    flex-shrink: 0;
    .vip-style {
      border-radius: 5px 5px 0 0 !important;
    }
    .vip-guide {
      width: 400px;
      display: flex;
      // align-items: center;
      // min-height: 38px;
      background: #ffe8bb;
      border-radius: 0px 0px 4px 4px;
      color: #64460d;
      padding: 8px 10px;
      img {
        width: 14px;
        height: 14px;
        margin: 3px 4px 0 0;
      }
      .guide-content {
        width: 100%;
        display: flex;
      }
      .open-vip {
        width: 80px;
        cursor: pointer;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        img {
          margin-bottom: 3px;
        }
      }
    }
  }

  .right {
    position: relative;
    flex-grow: 1;
    margin-bottom: 31px;
    display: flex;
    // flex-flow: row wrap;
    justify-content: space-between;
    flex-direction: column;
  }

  .title-wrap {
    margin-bottom: 14px;
  }

  .tag-cert {
    height: 20px;
    margin-right: 6px;
    vertical-align: -3px;
  }

  .title {
    font-size: 20px;
    font-weight: 500;
    color: rgba(32, 36, 42, 1);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .period {
    font-size: 14px;
    color: #999999;
    line-height: 1;
    display: flex;

    .ver-line {
      width: 1px;
      margin: 0 9px;
      background: #d9d9d9;
      display: inline-block;
    }
  }

  .share {
    width: 20px;
    height: 20px;
    position: absolute;
    background-image: url("~@/assets/images/common/share@2x.png");
    background-size: 100% 100%;
    top: 28px;
    right: 23px;
    cursor: pointer;
    &:hover {
      background-image: url("~@/assets/images/common/share-hover@2x.png");
    }
  }

  .apply {
    font-size: 14px;
    line-height: 1;
    display: flex;

    .left {
      width: 160px;
    }

    .item {
      margin-bottom: 20px;
    }

    .label {
      margin-right: 8px;
      color: #999999;
    }
  }

  .coupon-service-wrap {
    background: #fafafa;
    border-radius: 2px;
    padding: 17px 0 0 10px;
    margin: 0 0 24px 0px;
  }

  .coupon-wrap {
    display: flex;
    align-items: flex-start;

    .label {
      flex-shrink: 0;
      color: #999999;
      font-size: 14px;
      margin-right: 22px;
    }

    /deep/ {
      .coupon-wrap {
        position: static;
      }
    }
  }

  .placeholder {
    height: 68px;
  }

  .footer {
    // padding: 0 0 32px 0;
  }
}
</style>
